export const GET_ALL_USERS = "GET_ALL_USERS"
export const GET_ALL_ADMIN_USERS_RESPONSE_SUCCESS =
  "GET_ALL_ADMIN_USERS_RESPONSE_SUCCESS"

export const CREATE_USER = "CREATE_USER"

export const DELETE_USER = "DELETE_USER"

export const UPDATE_USER = "UPDATE_USER"
